export default {
	messages: {
		general: {
			no_alerts: "No alerts found",
			no_attachments: "Looks like you're a little short on attachments",
			drop_files_here: "Drop your file(s) in here",
			no_values_for_this_date: "No values found for this date",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/messages/messages_en-gb.js